const Cassie = () => {
    return (
        <>
            <h3 className="text-center">Cassie</h3>
        </>
    )
}

export default Cassie;